module.exports = ".innerContainer{\n    position:absolute; \n    top:15%; \n    bottom:0; \n    right:0;\n    left:0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/okta-custom-callback/okta-custom-callback.component.css
// module id = ./src/app/components/okta-custom-callback/okta-custom-callback.component.css
// module chunks = main